





































































































import {Component, PropSync, Watch} from 'vue-property-decorator'
import {Getter, Action} from 'vuex-class';
import { SelectWings, ToggleWings, NumberWings} from 'wings-ui-components';
import {DuplicateFilter, DuplicateFilterImpl} from '@/store/settings/duplicates/types';
import BaseFilter from '@/components/Filter/BaseFilter';
import {notifyError} from '@/utils/notify-helper';
import {getTranslatedParams} from "@/utils/notify-utils";
import {TransportItem} from "@/store/transport/types";
import {MsgTransports} from "@/store/types";

@Component({
  components: {SelectWings, ToggleWings, NumberWings},
})
export default class DuplicatesFilter extends BaseFilter<DuplicateFilter> {

  @PropSync('show') is_show!: boolean;

  @Action('getTransports') actionGetTransports: any;
  @Action('getPartners') actionGetPartners: any;
  @Action('getTemplates') actionGetTemplates: any;
  @Action('getDuplicates') actionGetDuplicates: any;

  @Getter('transports') transportsList: any;

  defaultFilter(): DuplicateFilter {
    return new DuplicateFilterImpl();
  }

  partnersList: any = []
  templatesList: any = []

  get transportsForDuplicatesList(): TransportItem[] {
    const validTransports = new Set<string>([
      MsgTransports.SMS,
      MsgTransports.VIBER,
      MsgTransports.PUSH,
      MsgTransports.WHATSAPP,
      MsgTransports.EMAIL,
      MsgTransports.MAILNOTIFY,
      MsgTransports.CUSTOM,
    ]);

    return this.transportsList.filter((t: TransportItem) => validTransports.has(t.name));
  }

  async getPartnersList(filter: any) {
    if (!this.filter.channel) return
    const items = await this.actionGetPartners({transport: this.filter.channel, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getTemplatesList(filter: any) {
    if (!this.filter.partner) return
    const items = await this.actionGetTemplates({transport: this.filter?.channel, filter: {partner: this.filter.partner, ...filter}});
    this.templatesList = (filter?.page_number > 1) ? this.templatesList.concat(items) : items
  }

  async created(): Promise<void> {
    try {
      this.actionGetTransports();
      this.filtered();
    } catch (error) {
      notifyError(error);
    }
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.template) this.templatesList = await this.actionGetTemplates({transport: this.filter?.channel, filter: {name: this.filter.template}});
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "SMPP connection",
        addititional_info: getTranslatedParams(this.filter)
      };
      await this.actionGetDuplicates(this.filter);
      await this.actionLog(this.logObject);
    }
    catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }

  @Watch('filter.channel')
  onChannelChanged(val?: string, oldVal?: string): void {
    if (oldVal && val !== oldVal) {
      this.unsetFilter('partner');
      this.unsetFilter('template');
    }
  }

  @Watch('filter.partner')
  onPartnerChanged(val?: string, oldVal?: string): void {
    if (oldVal && val !== oldVal) {
      this.unsetFilter('template');
    }
  }
}
